<div *ngIf="inventoryDetailsPagesData && inventoryDetailsPagesData.length === 0 && tabName !== 'Nomination'" class="d-flex flex-column h-100 justify-content-center align-items-center text-gray-450 fw-bold">
    <h2>
        No movements yet
    </h2>
</div>
<div *ngIf="inventoryDetailsPagesData && inventoryDetailsPagesData.length === 0 && tabName === 'Nomination'" class="d-flex flex-column h-100 justify-content-center align-items-center text-gray-450 fw-bold">
    <h2>
        No movements yet
    </h2>
</div>
<div #quotesPage *ngIf="inventoryDetailsPagesData.length > 0 && tabName !== 'Nomination'">
    <div class="container pr-0 mw-100">
        <!-- Confirmation Message after Event trogger -->
        <!-- <div class="confirmation-msg-style" *ngIf="true">
            <div><span class="inline-cross-quote text-success pl-3" *ngIf="true">
                {{ 'home.quote.bidPlacedSuccess' | cxTranslate }}</span>
            </div>
            <div class="inline-cross-quote cross">
                <button class="btn"><i class="fa fa-times text-success" aria-hidden="true"></i></button>
            </div>
        </div> -->
        <!--Card-->
        <div>
            <div class="card pt-3 pb-3 pl-4 pr-4 mb-4 card-border border-radius-05" *ngFor="let data of inventoryDetailsPagesData;let i = index">
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center">
                        <!-- <div class="bid-status-text" [ngClass]="data.quoteStatus|quoteStatusStyle">{{ data.quoteStatus | titlecase }}</div> -->
                        <div class="bid-status-text" [ngClass]="data.quoteStatus|quoteStatusStyle" *ngIf="data.quoteStatus=='ACCEPTED'">Accepted</div>
                        <div class="bid-status-text  ml-2" [ngClass]="data.quoteStatus|quoteStatusStyle" *ngIf="data.quoteStatus=='ACCEPTED'&&data.isPickedUp">Picked up</div>
                        <div class="bid-status-text offerReceived" *ngIf="data.quoteStatus === 'BID_RECEIVED' || data.quoteStatus === 'BID_PLACED'">Bid placed</div>
                        <div class="bid-status-text offerReceived" *ngIf="data.quoteStatus === 'OFFER_RECEIVED'">Offer received</div>
                        <!-- <div class="bid-status-text" [ngClass]="data.quoteStatus|quoteStatusStyle" *ngIf="data.quoteStatus=='ACCEPTED'&&!data.isPickedUp">Accepted</div> -->
                        <div class="bid-status-text" [ngClass]="data.quoteStatus|quoteStatusStyle" *ngIf="data.quoteStatus=='BID_EXPIRED'">Bid expired</div>
                        <div class="bid-status-text" [ngClass]="data.quoteStatus|quoteStatusStyle" *ngIf="data.quoteStatus === 'REJECTED' || data.quoteStatus === 'CANCELLED'">{{ data.quoteStatus | titlecase }}</div>
                        <div class="bid-status-text" [ngClass]="data.quoteStatus|quoteStatusStyle" *ngIf="data.quoteStatus === 'OFFER_EXPIRED'">Offer expired</div>
                        <!-- <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'BID_RECEIVED' || data.quoteStatus === 'BID_PLACED') && data.creationDate">{{ '   Validity:' }} {{ data.creationDate | date : 'yy/MM/dd HH:mm' }}</div>
                        <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'OFFER_RECEIVED') && data.validity">{{ '   Validity:' }} {{ data.validity | date : 'yy/MM/dd HH:mm' }}</div> -->
                        <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'BID_RECEIVED' || data.quoteStatus === 'BID_PLACED') && data.validity">{{ '   Validity:' }} {{ convertDateAndTime(data.validity) }}</div>
                        <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'OFFER_RECEIVED') && data.validity">{{ '   Validity:' }} {{ convertDateAndTime(data.validity) }}</div>
                        <div class="small text-secondary visible-xs ml-2 text-danger ff-semibold" *ngIf="(data.quoteStatus === 'BID_RECEIVED' || data.quoteStatus === 'BID_PLACED' || data.quoteStatus === 'OFFER_RECEIVED') && data.validity && showExpireTime">{{ expiresTime(i) }}</div>
                    </div>
                    <div class="d-flex">
                        <span class="small text-secondary visible-xs mr-1">ID :{{data.quoteId}}</span> &nbsp;
                        <span class="small text-secondary visible-xs">Creation Date: {{convertDateOnly(data.creationDate)}}</span>
                    </div>
                </div>
                <div class="hr"></div>
                <div class="inside-layout  align-self-stretch">
                    <div class="pb-2">
                        <div class="h5 mb-0 text-secondary">Customer</div>
                        <div class="h5 mb-0 fw-bold">{{data.customer | titlecase}}</div>
                    </div>
                    <div class="d-flex visible-xs ml-auto">
                        <div class="visible-xs">
                            <div class="small text-secondary mr-4 pr-3">Price (per WMT):</div>
                            <div class="strong">{{ data.price| currency: "JPY":"symbol":"1.2-2"}}</div>
                        </div>
                        <div class="visible-xs mr-4 pr-3">
                            <div class="small text-secondary">Quantity (WMT): </div>
                            <div class="strong">{{ data.quantity | number :"1.0"}}</div>
                        </div>
                        <!-- <div class="visible-xs mr-4 pr-3" *ngIf="data.quoteStatus=='ACCEPTED'">
                            <div class="small text-secondary">Collected</div>
                            <div class="strong">{{data.collected | number :"1.0"}}</div>
                        </div>
                        <div class="visible-xs" *ngIf="data.quoteStatus=='ACCEPTED'">
                            <div class="small text-secondary">To pick up</div>
                            <div class="strong">{{data.toPickup | number :"1.0"}}</div>
                        </div> -->
                    </div>
                    <div class="d-flex hidden-xs">
                        <div class="hidden-xs mr-4 pr-3">
                            <div class="small text-secondary">Price (per WMT):</div>
                            <div class="strong">{{ data.price| currency: "JPY":"symbol":"1.2-2"}}</div>
                        </div>
                        <div class="hidden-xs">
                            <div class="small text-secondary">Quantity (WMT): </div>
                            <div class="strong">{{ data.quantity | number :"1.0"}}</div>
                        </div>
                    </div>
                </div>
                <div class="hr"></div>
                <div class="d-flex   align-self-stretch">
                    <div class="viewdetails ">
                        <a class="strong  text-primary " href={{data.respondToBidURL}} target="_blank">
                            View details in SCRM >
                        </a>
                    </div>
                    <div class="ml-auto" *ngIf="data.quoteStatus=='BID_RECEIVED' || data.quoteStatus=='BID_PLACED'">
                        <button class="btn btn-primary record-pickup-btn" (click)="respondToBid(i)">Respond to bid</button>
                    </div>
                  <!--  <div class="ml-auto" *ngIf="data.quoteStatus=='ACCEPTED'&&!data.isPickedUp">
                        <button class="btn btn-primary record-pickup-btn" (click)="recordPickup(i,data)">Record pick up</button>
                    </div>-->
                </div>
            </div>
        </div>
    </div>
</div>
<div #quotesPage *ngIf="inventoryDetailsPagesData.length > 0 && tabName === 'Nomination'">
    <div class="container pr-0 mw-100">
        <div>
            <div class="card pt-3 pb-3 pl-4 pr-4 mb-4 card-border border-radius-05" *ngFor="let data of inventoryDetailsPagesData;let i = index">
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center">
                        <div class="bid-status-text">In Nomination</div>
                        <!-- <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'BID_RECEIVED' || data.quoteStatus === 'BID_PLACED') && data.creationDate">{{ '   Validity:' }} {{ data.creationDate | date : 'yy/MM/dd HH:mm' }}</div>
                        <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'OFFER_RECEIVED') && data.validity">{{ '   Validity:' }} {{ data.validity | date : 'yy/MM/dd HH:mm' }}</div> -->
                        <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'BID_RECEIVED' || data.quoteStatus === 'BID_PLACED') && data.validity">{{ '   Validity:' }} {{ convertDateAndTime(data.validity) }}</div>
                        <div class="small text-secondary visible-xs ml-2" *ngIf="(data.quoteStatus === 'OFFER_RECEIVED') && data.validity">{{ '   Validity:' }} {{ convertDateAndTime(data.validity) }}</div>
                        <div class="small text-secondary visible-xs ml-2 text-danger ff-semibold" *ngIf="(data.quoteStatus === 'BID_RECEIVED' || data.quoteStatus === 'BID_PLACED' || data.quoteStatus === 'OFFER_RECEIVED') && data.validity && showExpireTime">{{ expiresTime(i) }}</div>
                    </div>
                    <div class="d-flex">
                        <span class="small text-secondary visible-xs mr-1">Batch ID :{{data.batchNumber}}</span> &nbsp;
                        <span class="small text-secondary visible-xs">Date: {{convertDateOnly(data.scheduledTimestampFrom)}}</span>
                    </div>
                </div>
                <div class="hr"></div>
                <div class="inside-layout  align-self-stretch">
                    <div class="pb-2">
                        <div class="h5 mb-0 text-secondary">CTContract</div>
                        <div class="h5 mb-0 fw-bold">{{data.contractNumber}}</div>
                    </div>
                    <div class="d-flex visible-xs ml-auto">
                        <div class="visible-xs">
                            <div class="small text-secondary mr-4 pr-3">Nomination Item No:</div>
                            <div class="strong">{{ data.nominationNumber}}</div>
                        </div>
                        <div class="visible-xs mr-4 pr-3">
                            <div class="small text-secondary">Scheduled Quantity: </div>
                            <div class="strong">{{ data.scheduledQuantity | number :"1.0"}}</div>
                        </div>
                        <div class="visible-xs mr-4 pr-3">
                            <div class="small text-secondary">Collected</div>
                            <div class="strong">{{data.collectedQty | number :"1.0"}}</div>
                        </div>
                        <div class="visible-xs">
                            <div class="small text-secondary">To pick up</div>
                            <div class="strong">{{data.toPickUp ? data.toPickUp : "0"}}</div>
                        </div>
                    </div>
                    
                    <div class="d-flex hidden-xs">
                        <div class="hidden-xs mr-4 pr-3">
                            <div class="small text-secondary">Nomination Item No:</div>
                            <div class="strong">{{ data.nominationNumber}}</div>
                        </div>
                        <div class="hidden-xs">
                            <div class="small text-secondary">Scheduled Quantity:</div>
                            <div class="strong">{{ data.scheduledQuantity | number :"1.0"}}</div>
                        </div>
                    </div>
                </div>
                <div class="hr"></div>
                <div class="d-flex   align-self-stretch">
                    <!-- <div class="viewdetails ">
                        <a class="strong  text-primary " href={{data.respondToBidURL}} target="_blank">
                            View details in SCRM >
                        </a>
                    </div>
                    <div class="ml-auto" *ngIf="data.quoteStatus=='BID_RECEIVED' || data.quoteStatus=='BID_PLACED'">
                        <button class="btn btn-primary record-pickup-btn" (click)="respondToBid(i)">Respond to bid</button>
                    </div> -->
                    <div class="ml-auto">
                        <button class="btn btn-primary record-pickup-btn" (click)="recordPickup(i,data)">Record pick up</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>